import { z } from "zod";
import { aresCompanySchema } from "@/types/schemas/ares";
import { attachmentSchema } from "@/types/schemas/attachment";

export type AresCompany = z.infer<typeof aresCompanySchema>;

export type Attachment = z.infer<typeof attachmentSchema>;

export enum Units {
  mwh = "mwh",
  kwh = "kwh",
  m3 = "m3",
}

export interface FormInputProps {
  onChange: () => void;
  value?: string;
  checked?: boolean;
  error?: string;
  onFocus?: () => void;
  onBlur?: () => void;
}
